module.exports = __webpack_public_path__ + "media/day/350-9d65c345.svg";